import { render, staticRenderFns } from "./ResearchTrack.vue?vue&type=template&id=76f32279&scoped=true&"
import script from "./ResearchTrack.vue?vue&type=script&lang=ts&"
export * from "./ResearchTrack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f32279",
  null
  
)

export default component.exports